<div class="inicio">
  <p class="titulo">
    REASIGNACIÓN DE EQUIPOS
    <button
      mat-mini-fab
      color="primary"
      matTooltip="Click para más información"
      (click)="clickMasInformacion($event)"
    >
      <mat-icon>info</mat-icon>
    </button>
  </p>

  <div class="grid-container3">
    <div class="grid-container">
      <div class="celda">
        <mat-label class="texto"
          >Remover equipos de:
          <mat-label class="advertencia">*</mat-label></mat-label
        >
        <mat-form-field appearance="fill">
          <mat-select
            [disabled]="loadingColaboradores"
            [formControl]="input_Empleado_libera"
            #singleSelect1
            (selectionChange)="llenarData($event)"
          >
            <mat-option>
              <ngx-mat-select-search
                [formControl]="input_colaboradorSalida"
                oninput="this.value = this.value?.toUpperCase()"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let option of listaFiltradaColaboradores_Salida | async"
              [value]="option"
            >
              {{ option.nomb_compl }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="grid-container">
      <div class="celda">
        <mat-label class="texto"
          >Asignarle equipos a:
          <mat-label class="advertencia">*</mat-label></mat-label
        >
        <mat-form-field appearance="fill">
          <mat-select
            [disabled]="loadingColaboradores"
            [formControl]="input_Empleado_reasig"
            #singleSelect2
            (selectionChange)="clickSeleccionEmpleadoR($event)"
          >
            <mat-option>
              <ngx-mat-select-search
                [formControl]="input_colaboradorRecibe"
                oninput="this.value = this.value?.toUpperCase()"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let option of listaFiltradaColaboradores_Reasig | async"
              [value]="option"
            >
              {{ option.nomb_compl }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="example-button-container">
      <button
        mat-raised-button
        color="primary"
        matTooltip=""
        [disabled]="habilitarBotonesReasignacion()"
        (click)="clickReasignar($event)"
      >
        Reasignar<mat-icon>save</mat-icon>
      </button>
    </div>
  </div>
  <mat-progress-bar
    *ngIf="loadingColaboradores"
    mode="indeterminate"
  ></mat-progress-bar>
  <h4
    *ngIf="loadingColaboradores"
    style="
      background-color: antiquewhite;
      text-align: center;
      border-radius: 10px;
    "
  >
    <strong>Cargando información espere un momento...</strong>
  </h4>

  <div>
    <div class="grid-container">
      <mat-form-field>
        <mat-label>BUSCAR</mat-label>
        <input
          matInput
          placeholder="INGRESE DATO A BUSCAR"
          (keyup)="filtroDataDourceEquipos($event)"
        />
      </mat-form-field>
    </div>

    <mat-progress-bar mode="indeterminate" *ngIf="cargando"></mat-progress-bar>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="OPCIONES">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            class="example-margin"
            [disabled]="!habilitarCheckAll()"
            (change)="clickCheckAll($event.checked)"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            class="example-margin"
            [(ngModel)]="element.bandera"
          ></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="NOMBRE">
        <th mat-header-cell *matHeaderCellDef>NOMBRE</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="TIPO">
        <th mat-header-cell *matHeaderCellDef>TIPO</th>
        <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
      </ng-container>

      <ng-container matColumnDef="MODELO">
        <th mat-header-cell *matHeaderCellDef>MODELO</th>
        <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
      </ng-container>

      <ng-container matColumnDef="SERIE">
        <th mat-header-cell *matHeaderCellDef>SERIE</th>
        <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
      </ng-container>

      <ng-container matColumnDef="FABRICANTE">
        <th mat-header-cell *matHeaderCellDef>FABRICANTE</th>
        <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="encabezados"></tr>
      <tr mat-row *matRowDef="let row; columns: encabezados"></tr>
    </table>

    <div class="no-result" *ngIf="!cargando && !dataSource.data.length">
      Sin resultados.
    </div>

    <mat-paginator
      #paginatorS
      class="mat-elevation-z8"
      [pageSize]="10"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
